import React from 'react';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import columns from './columns';
import { BRAND_LIST_TABLE_EMPTY_TEXT } from '../../../../../constants/service/app/brandConstants';
import {
  BRAND_LIST_FILTER_OPTION_MODEL,
  BRAND_LIST_SORT_OPTION_MODEL,
} from '../../../../../store/modules/brand/models';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';

const BrandAllList = (props) => {
  const { brandAllList, currentTierList, getList, getExcelDownload, getBrandTagColumnTagList } = props;
  const { list, filterOption, sortOption, pagination, summary } = brandAllList;

  return (
    <div className="brand-all-list">
      <TableWithSummary
        data={list}
        totalCnt={summary.totalCnt}
        initialOption={{
          filterOption: BRAND_LIST_FILTER_OPTION_MODEL,
          sortOption: BRAND_LIST_SORT_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        }}
        isStriped={true}
        emptyText={BRAND_LIST_TABLE_EMPTY_TEXT}
        showPagination
        filterOption={filterOption}
        sortOption={sortOption}
        pagination={pagination}
        getList={getList}
        getExcelDownload={getExcelDownload}
        columns={(utils) =>
          columns({
            currentTierList,
            getBrandTagColumnTagList,
            ...utils,
          })
        }
      />
    </div>
  );
};

export default BrandAllList;
